import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import moment from 'moment';

import Img from 'retired/Img';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';
import NonprofitLink from 'retired/NonprofitLink';
import { AmountCurrencies, currenciesFormat, CurrencyCode } from 'utils/currencyFormat';
import { blackish } from 'utils/color-styles';
import { DeedListDateInfoWithStatus } from 'components/DeedListDateInfoWithStatus';
import { deedStyles } from 'containers/VolunteerPage/deedStyles';
import { DonationSchedule, DonationScheduleStatus } from 'generated/graphql';
import { Chip } from 'components/Chip';

const DonationScheduleRow = ({ donationSchedule }: { donationSchedule: DonationSchedule }) => (
  <Link style={{ color: blackish }} to={`/donations/schedules/${donationSchedule.id}`}>
    <div style={deedStyles}>
      <DeedListDateInfoWithStatus date={donationSchedule.startingAt}></DeedListDateInfoWithStatus>
      <div style={{ flexGrow: 1, marginLeft: 28 }}>
        <Grid container alignItems="center">
          <Grid item xs={8} style={{ height: '100%', margin: '0 !important' }}>
            <h3
              style={{
                fontSize: 15,
                fontWeight: 500,
                margin: '0px 0px 7px',
              }}
            >
              {(donationSchedule.nonprofits || []).map((nonprofit, i) => (
                <React.Fragment key={nonprofit.id}>
                  <NonprofitLink nonprofit={nonprofit} />
                  {i + 1 < (donationSchedule.nonprofits || []).length ? ', ' : ''}
                </React.Fragment>
              ))}

              <Chip
                size="small"
                label={donationSchedule.status}
                color={
                  donationSchedule.status === DonationScheduleStatus.Active ? 'primary' : 'default'
                }
                style={{ marginLeft: 10, borderRadius: 4, fontSize: 10 }}
              />
              {donationSchedule.endingAt ? (
                <Chip
                  size="small"
                  label={`${
                    moment(donationSchedule.endingAt).isBefore(moment()) ? 'Ended' : 'Ending'
                  } At: ${moment(donationSchedule.endingAt).format('MMM DD, YYYY')}`}
                  color={'error'}
                  style={{ marginLeft: 10, borderRadius: 4, fontSize: 10 }}
                />
              ) : null}
            </h3>
            <div style={{ fontSize: 12 }}>
              Amount:{' '}
              {currenciesFormat(
                { [donationSchedule.currencyCode]: donationSchedule.amount } as AmountCurrencies,
                donationSchedule.currencyCode as CurrencyCode
              )}
            </div>
          </Grid>
          <Grid item xs={4}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                height: 93,
                paddingTop: 5,
                overflow: 'hidden',
                alignItems: 'flex-end',
              }}
            />
          </Grid>
        </Grid>
      </div>
      <div style={{ lineHeight: '100px' }}>
        <Img
          src={ArrowRightIcon}
          alt=""
          style={{
            height: 24,
            verticalAlign: 'middle',
            marginLeft: 38,
            marginRight: 38,
          }}
        />
      </div>
    </div>
  </Link>
);

export default DonationScheduleRow;
